import { render, staticRenderFns } from "./whitelabel-settings.vue?vue&type=template&id=f7df7d7c&scoped=true"
import script from "./whitelabel-settings.vue?vue&type=script&lang=js"
export * from "./whitelabel-settings.vue?vue&type=script&lang=js"
import style0 from "./whitelabel-settings.vue?vue&type=style&index=0&id=f7df7d7c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7df7d7c",
  null
  
)

export default component.exports